import { parseDate } from '@eui-util/date';
import _sortBy from 'lodash/sortBy';
import _sumBy from 'lodash/sumBy';

/**
 * Takes a list of budget transactions and groups them into month and year.
 *
 * @param transactions
 * @returns {[]}
 */
export default function (transactions) {
  let groups = {};
  if (!transactions || !Array.isArray(transactions)) {
    return [];
  }

  // Sort transactions by year and months
  transactions.forEach((transaction) => {
    const transactionDate = parseDate(
      transaction.date,
      undefined,
      'yyyy-MM-dd'
    );
    const parsedDate = new Date(transactionDate);
    const year = parsedDate.getFullYear();
    const month = parsedDate.getMonth();

    groups[year] = groups[year] || {};
    groups[year][month] = groups[year][month] || {
      transactionDate: undefined,
      transactions: []
    };
    groups[year][month].transactionDate = transactionDate;
    groups[year][month].transactions.push(transaction);
  });

  // Reduce transactions into a sorted list by groups of year and month
  const result = [];
  const numberYears = Object.keys(groups).map((val) => Number(val));
  const years = _sortBy(numberYears)
    .reverse()
    .map((val) => val.toString());
  years.forEach((year) => {
    const yearGroup = groups[year];
    const numberMonths = Object.keys(yearGroup).map((val) => Number(val));
    const months = _sortBy(numberMonths)
      .reverse()
      .map((val) => val.toString());
    months.forEach((month) => {
      const monthGroup = yearGroup[month];
      const totalBalance = _sumBy(monthGroup.transactions, 'transactionAmount');
      result.push({
        groupDate: parseDate(
          monthGroup.transactionDate,
          'yyyy-MM-dd',
          'MMM yyyy'
        ),
        totalBalance,
        transactions: monthGroup.transactions
      });
    });
  });

  return result;
}
